import React, { useState } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Stack, Typography } from '@mui/material';

type CancelTaskConfirmationDialogProps = {
  onConfirm: () => Promise<void>;
  onClose: () => void;
};

const CancelTaskConfirmationDialog = ({ onConfirm, onClose }: CancelTaskConfirmationDialogProps) => {
  const { t } = useTranslation();
  const [canceling, setCanceling] = useState<boolean>(false);
  const handleConfirm = () => {
    setCanceling(true);

    // eslint-disable-next-line promise/catch-or-return
    onConfirm().finally(() => {
      setCanceling(false);
    });
  };

  return (
    <Dialog
      dataTestId="schedule-task-cancel-confirmation-dialog"
      open
      title={t('hiring-dashboard-tasks:tasks.cancelTask.title')}
      subTitle={t('hiring-dashboard-tasks:tasks.cancelTask.subtitle')}
      submitOptions={{
        dataTestId: 'schedule-task-cancel-confirm-button',
        label: t('hiring-dashboard-tasks:tasks.cancelTask.confirmLabel'),
        isDangerous: true,
        isDisabled: canceling,
        isLoading: canceling,
        onClick: handleConfirm,
      }}
      cancelOptions={{
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: onClose,
      }}
      onClose={onClose}
    >
      <Stack spacing={2}>
        <Typography>{t('hiring-dashboard-tasks:tasks.cancelTask.body')}</Typography>
      </Stack>
    </Dialog>
  );
};

export default CancelTaskConfirmationDialog;
